import { api } from "./api";

const RETRIES = 3;

const wait = (milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds));

export async function preflightMobileCapture(file, options = {}) {
  if (!file) throw new Error("Nenhuma foto selecionada");
  const body = new FormData();
  body.append("file", file, file.name || "cartao-preflight.jpg");
  if (options.examId) body.append("exam_id", options.examId);
  if (options.sourceWidth) body.append("source_width", String(options.sourceWidth));
  if (options.sourceHeight) body.append("source_height", String(options.sourceHeight));
  if (options.manualCorners) body.append("manual_corners", JSON.stringify(options.manualCorners));
  return api.post("/omr/mobile-preflight", body, { timeout: 30000 });
}

export async function uploadOmrBatch(files, options = {}) {
  const selected = Array.from(files || []);
  if (!selected.length) throw new Error("Nenhum arquivo selecionado");

  const init = await api.post("/omr/uploads/init", {
    files: selected.map((file) => ({ name: file.name, size: file.size, type: file.type })),
    class_id: options.classId || null,
    semester_id: options.semesterId || null,
    exam_id: options.examId || null,
    scanner_id: options.scannerId || "default",
    manual_corners: options.manualCorners || null,
  });
  const uploadId = init.data.upload_id;
  const chunkSize = Number(init.data.chunk_size);
  const totalBytes = selected.reduce((sum, file) => sum + file.size, 0);
  let confirmedBytes = 0;

  try {
    for (let fileIndex = 0; fileIndex < selected.length; fileIndex += 1) {
      const file = selected[fileIndex];
      const chunks = Math.ceil(file.size / chunkSize);
      for (let chunkIndex = 0; chunkIndex < chunks; chunkIndex += 1) {
        const start = chunkIndex * chunkSize;
        const blob = file.slice(start, Math.min(file.size, start + chunkSize));
        let lastError;
        for (let attempt = 1; attempt <= RETRIES; attempt += 1) {
          try {
            await api.post(
              `/omr/uploads/${uploadId}/files/${fileIndex}/chunks/${chunkIndex}`,
              blob,
              {
                headers: { "Content-Type": "application/octet-stream" },
                timeout: 180000,
                onUploadProgress: (event) => {
                  const current = Math.min(blob.size, event.loaded || 0);
                  const percent = Math.floor(((confirmedBytes + current) / totalBytes) * 100);
                  options.onProgress?.(Math.min(99, percent));
                },
              },
            );
            lastError = null;
            break;
          } catch (error) {
            lastError = error;
            if (attempt < RETRIES) await wait(700 * attempt);
          }
        }
        if (lastError) throw lastError;
        confirmedBytes += blob.size;
        options.onProgress?.(Math.min(99, Math.floor((confirmedBytes / totalBytes) * 100)));
      }
    }
    const result = await api.post(`/omr/uploads/${uploadId}/finalize`, null, { timeout: 180000 });
    options.onProgress?.(100);
    return result;
  } catch (error) {
    try { await api.delete(`/omr/uploads/${uploadId}`); } catch { /* best-effort cleanup */ }
    throw error;
  }
}
